import { auth, googleProvider, microsoftProvider } from '../Services/firebase';
import { signInWithPopup } from 'firebase/auth';
import { Form, Button } from 'react-bootstrap';
import { ReactComponent as GoogleIcon } from '../assets/icons/Google__G__logo.svg';
import './css/AccountFederatedSignIn.css';

export const AccountFederatedSignIn = () => {
    const handleSignIn = async (provider: 'google' | 'microsoft') => {
        const selectedProvider = provider === 'google' ? googleProvider : microsoftProvider;

        try {
            const result = await signInWithPopup(auth, selectedProvider);
            const user = result.user;
            console.log(`Welcome, ${user.displayName}`);
            // TODO: redirect or update session state
        } catch (err: unknown) {
            if (err instanceof Error) {
                console.error(`Sign-in failed: ${err.message}`);
                // TODO: show editorial error message to user
            } else {
                console.error('Sign-in failed with an unknown error:', err);
            }
        }
    };

    return (
        <Form className="federated-signin">
            <Button variant="outline-primary" className="signin-button google" onClick={() => handleSignIn('google')}>
                <GoogleIcon className="icon" aria-hidden="true" />
                <span>Sign in with Google</span>
            </Button>
        </Form>
    );
};
